export enum View {
  StartingPoint = 'StartingPoint',
  GuidedSetup = 'GuidedSetup',
  None = 'None',
}

export type ViewListItem = {
  title: string;
  iconSrc: string;
  navigationTarget?: string;
  // Used for logging (does not represent Amplitude event name)
  eventName?: string;
  bodyContent: React.ReactChild;
};

export type ViewContent = {
  [View.StartingPoint]: ViewListItem[];
  [View.GuidedSetup]: ViewListItem[];
};

export type MenuItem = {
  title: string;
  bodyContent: React.ReactChild;
  iconSrc: string;
  eventName?: string;
};

export type HrefMenuItem = MenuItem & {
  href: string;
};
export const isHrefMenuItem = (item: MenuItem): item is HrefMenuItem =>
  Boolean((item as HrefMenuItem).href);

export type ClickMenuItem = MenuItem & {
  onClick(this: void): void;
};
export const isClickMenuItem = (item: MenuItem): item is ClickMenuItem =>
  Boolean((item as ClickMenuItem).onClick);

export enum ExperimentVariant {
  DrillDownMenu = 'create-18931-create-survey--drill-down',
  SingleLevelMenu = 'create-18931-create-survey--single-level',
}

export enum ClickMetricEventName {
  StartFromScratch = 'Start with a blank survey',
  CopyAndPaste = 'Copy and paste from doc',
  Solution = 'Insights solutions',
  BuildItForMe = 'In-product guidance',
  Template = 'Popular template',
  Audience = 'Buy targeted responses',
}
